import styled from 'styled-components';

export const HeadTitleWrap = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 0 20px 20px;

  * {
    align-items: center;
    padding: 0;
  }
`;

export const ListTitle = styled.div`
  padding: 28px 20px 8px;
`;

export const AdImage = styled.img`
  width: 100%;
`;

export const Divider = styled.div`
  height: 12px;
  background-color: #f7f7f7;
`;

export const BottomEmptySpace = styled.div`
  height: 285px;
`;

export const FloatingBox = styled.div`
  position: sticky;
  bottom: 32px;
  transition: bottom 0.2s;
  padding: 0 20px 20px 20px;
  width: 100vw;
  box-sizing: border-box;
  z-index: 99;
`;

export const ButtonText = styled.span`
  color: #363636;
`;
